import { render, staticRenderFns } from "./subCategories.vue?vue&type=template&id=b44e2d78&scoped=true&"
import script from "./subCategories.vue?vue&type=script&lang=js&"
export * from "./subCategories.vue?vue&type=script&lang=js&"
import style0 from "./subCategories.vue?vue&type=style&index=0&id=b44e2d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44e2d78",
  null
  
)

export default component.exports